import cn from 'classnames';
import { FC, useEffect, useState } from 'react';
import { Crop } from 'react-image-crop';
import { QrCode } from '../../../../../../../../../components/qr-code/qr-code';
import { QrTextPlacementType } from '../../helpers';
import { useWrappedQrCode } from './use-wrapped-qr-code';
import s from './wrapped-qr-code.module.css';

interface Props {
  data?: string;
  size?: number;
  label?: string;
  labelPosition: QrTextPlacementType;

  img?: string; // для обертки
  crop?: Crop; // для обертки

  logo?: string;

  background?: string;
  dots?: string;
  textColor?: string;
}

export const WrappedQrCode: FC<Props> = (props) => {
  const {
    crop,
    data,
    img,
    label,
    size = 100,
    logo,
    labelPosition,
    background,
    dots,
    textColor,
  } = props;
  const { canvasRef, logoWithLabel, qrCrop, logoSize } = useWrappedQrCode(
    crop,
    label,
    size,
    logo,
    labelPosition,
  );

  const [imgSrc, setImgSrc] = useState<string | undefined>(img);

  useEffect(() => {
    if (img?.endsWith('.svg')) {
      fetch(img)
        .then((response) => response.text())
        .then((svg) => {
          const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
          setImgSrc(svgDataUrl);
        })
        .catch((error) => console.error('Failed to load SVG:', error));
    } else {
      setImgSrc(img);
    }
  }, [img]);

  return (
    <div className={cn(s.feature, s[labelPosition])} style={{ width: `${size}%` }}>
      {img && <img src={imgSrc} alt="qr" className={s.frame} />}
      <QrCode
        data={data}
        className={cn(s.qr, img && s.imaged)}
        style={qrCrop}
        size={size}
        canvasRef={canvasRef}
        bgColor={background}
        fgColor={dots}
        imageSettings={
          logoWithLabel
            ? {
                height: logoSize,
                width: logoSize,
                src: logoWithLabel,
              }
            : undefined
        }
      >
        {labelPosition !== 'center' && (
          <span className={cn(s.label, s[labelPosition])} style={{ color: textColor }}>
            {label}
          </span>
        )}
      </QrCode>
    </div>
  );
};
